import classNames from 'classnames';
import { ReactNode } from 'react';

import { PropsWithClassname } from '@/app/types';

export enum TitleMarginBottomSize {
  Small,
  Large,
}

interface DonationFormSectionProps extends PropsWithClassname {
  title?: string;
  description?: string;
  order?: number;
  children: ReactNode[];
  titleMarginBottomSize?: TitleMarginBottomSize;
  testId?: string;
}

const DonationFormSection = ({
  title,
  description,
  children,
  order,
  className,
  titleMarginBottomSize = TitleMarginBottomSize.Small,
  testId,
}: DonationFormSectionProps) => {
  const areSomeChildrenVisible = children.some((el) => !!el);

  if (!areSomeChildrenVisible) {
    return null;
  }

  return (
    <div className={classNames(className, 'mb-[32px]')} data-testid={testId}>
      {!!title && (
        <span
          className={classNames(
            'block text-[10px] lg:text-[12px] font-medium uppercase tracking-[3px] leading-[24px] lg:tracking-[4.5px]',
            {
              'mb-[8px]': !!description,
              'mb-[40px]': !description && titleMarginBottomSize === TitleMarginBottomSize.Large,
              'mb-[32px]': !description && titleMarginBottomSize === TitleMarginBottomSize.Small,
            },
          )}
        >
          {typeof order !== 'undefined' ? `${order}. ` : ''}
          {title}
        </span>
      )}
      {!!description && (
        <small className="block text-[12px] leading-[1.4] text-neutral-mid mb-[32px]">{description}</small>
      )}
      <div>{children}</div>
    </div>
  );
};

export default DonationFormSection;
